import { render } from "./RolledTag.vue?vue&type=template&id=5f90f9c5&ts=true"
import script from "./RolledTag.vue?vue&type=script&lang=ts"
export * from "./RolledTag.vue?vue&type=script&lang=ts"

import "./RolledTag.vue?vue&type=style&index=0&id=5f90f9c5&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__